// extracted by css-extract-rspack-plugin
export default {"issueTypeDot":"DefaultIssueTypePickerAnchor-module__issueTypeDot__tFF3h"};